import { Button, Dialog, Group } from '@economic/taco';
import React from 'react';
import { t } from '../../../../../../../shared/components/l10n/l10n';
import UpdatePlanSuccessIllustration from '../../../assets/Update-plan-success.svg';

const SuccessStep = ({ close }: { close: () => void }) => {
    return (
        <>
            <Dialog.Title>
                <div className="my-4">{t`SMARTPAY_CHANGE_PLAN_MODAL_SUCCESS_TITLE`}</div>
            </Dialog.Title>

            <div className="flex flex-col items-center">
                <span>{t`SMARTPAY_CHANGE_PLAN_MODAL_SUCCESS_MESSAGE`}</span>
                <img
                    src={UpdatePlanSuccessIllustration}
                    alt="Smart Pay update plan success graphic"
                    className="w-56 my-6 mx-auto"
                />
            </div>

            <Dialog.Footer>
                <Group>
                    <Button autoFocus appearance="primary" onClick={close}>
                        {t`SMARTPAY_CHANGE_PLAN_MODAL_CLOSE_BUTTON`}
                    </Button>
                </Group>
            </Dialog.Footer>
        </>
    );
};

export default SuccessStep;
